import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaOverviewPage } from './plaza-overview';

@NgModule({
  declarations: [
    PlazaOverviewPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaOverviewPage),
    TranslateModule.forChild()
  ],
})
export class PlazaOverviewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-overview/plaza-overview.module.ts